import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';


import { RedirectWhatsappPageRoutingModule } from './redirect-whatsapp-routing.module';

import { RedirectWhatsappPage } from './redirect-whatsapp.page';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    RedirectWhatsappPageRoutingModule
],
  declarations: [RedirectWhatsappPage]
})
export class RedirectWhatsappPageModule {}
